import { useState, useRef, useEffect } from "react";
import "./TopBar.css";
import { useNavigate } from "react-router-dom";
import UserButton from "../UserButton/UserButton";
import { useAuthenticator } from "@aws-amplify/ui-react";

const SHARE_URL = "https://platform.medrpt.ai";
const SHARE_TEXT = "Check out MedRPT — AI-powered medical literature synthesis platform";

const PLATFORMS = [
  {
    key: "bluesky",
    label: "Bluesky",
    color: "#0085ff",
    href: `https://bsky.app/intent/compose?text=${encodeURIComponent(SHARE_TEXT + " " + SHARE_URL)}`,
    icon: (
      <svg width="18" height="18" viewBox="0 0 600 530" fill="currentColor">
        <path d="M135.72 44.03C202.216 93.951 273.74 195.17 300 249.49c26.262-54.316 97.782-155.54 164.28-205.46C512.26 8.009 590-19.862 590 68.825c0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.38-3.69-10.832-3.708-7.896-.017-2.936-1.193.516-3.707 7.896-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.45-163.25-81.433C20.15 217.613 10 86.535 10 68.825c0-88.687 77.742-60.816 125.72-24.795z" />
      </svg>
    ),
  },
  {
    key: "twitter",
    label: "X / Twitter",
    color: "#000",
    href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_TEXT)}&url=${encodeURIComponent(SHARE_URL)}`,
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    key: "facebook",
    label: "Facebook",
    color: "#1877f2",
    href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(SHARE_URL)}`,
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    color: "#25d366",
    href: `https://wa.me/?text=${encodeURIComponent(SHARE_TEXT + " " + SHARE_URL)}`,
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
  {
    key: "email",
    label: "Email",
    color: "#6b7280",
    href: `mailto:?subject=${encodeURIComponent("MedRPT — AI-powered medical literature synthesis platform")}&body=${encodeURIComponent(SHARE_TEXT + "\n\n" + SHARE_URL)}`,
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" />
      </svg>
    ),
  },
];

export const TopBar = () => {
  const navigate = useNavigate();
  const { user } = useAuthenticator((context) => [context.user]);
  const [shareOpen, setShareOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setShareOpen(false);
      }
    };
    if (shareOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [shareOpen]);

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(SHARE_URL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="TopBar">
      <div className="MedRPT" onClick={() => navigate("/")}>
        <svg
          className="responsive-svg"
          viewBox="0 0 184 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M89.6724 10.9168H97.74C99.3525 10.9168 100.835 11.1788 102.187 11.7027C103.534 12.2266 104.696 12.9571 105.672 13.8891C106.649 14.821 107.4 15.9142 107.931 17.1736C108.462 18.4331 108.727 19.7932 108.727 21.2592V21.3196C108.727 22.7856 108.462 24.1559 107.931 25.4203C107.4 26.6898 106.644 27.788 105.672 28.72C104.696 29.652 103.534 30.3824 102.187 30.9215C100.84 31.4555 99.3576 31.7225 97.74 31.7225H89.6724V15.1737V10.9168ZM97.74 27.5916C98.6665 27.5916 99.5128 27.4455 100.279 27.1482C101.045 26.851 101.701 26.4228 102.242 25.8687C102.783 25.3145 103.209 24.6596 103.514 23.909C103.82 23.1534 103.97 22.3121 103.97 21.3801V21.3196C103.97 20.4078 103.82 19.5665 103.514 18.7958C103.209 18.025 102.783 17.36 102.242 16.8059C101.701 16.2517 101.045 15.8185 100.279 15.5112C99.5128 15.2039 98.6615 15.0528 97.74 15.0528H89.7124L89.6774 27.3447V27.5966H97.74V27.5916Z"
            fill="#01344A"
          />
          <path
            d="M44.2314 10.9168H49.1341L54.5727 19.7126L60.0112 10.9168H64.9139V31.7225H60.4218V18.1409L54.6027 27.0273H54.4825L48.7235 18.2316V31.7275H44.2314V10.9168Z"
            fill="#01344A"
          />
          <path
            d="M112.779 10.9168H122.234C124.853 10.9168 126.861 11.6221 128.264 13.0276C129.445 14.2165 130.036 15.8034 130.036 17.7832V17.8436C130.036 19.5262 129.626 20.9015 128.809 21.9594C127.993 23.0173 126.921 23.7982 125.604 24.2919L130.657 31.7225H125.339L120.907 25.0626H120.847H117.331V31.7225H112.779V10.9168ZM121.939 21.0224C123.06 21.0224 123.922 20.7554 124.523 20.2214C125.124 19.6874 125.424 18.9721 125.424 18.0804V18.02C125.424 17.0275 125.109 16.287 124.478 15.7933C123.847 15.2996 122.97 15.0528 121.849 15.0528H117.326V21.0224H121.939Z"
            fill="#49994C"
          />
          <path
            d="M134.142 10.9168H142.59C143.832 10.9168 144.939 11.0881 145.916 11.4357C146.892 11.7833 147.718 12.272 148.399 12.9067C149.081 13.5415 149.601 14.2971 149.967 15.1787C150.332 16.0603 150.513 17.0376 150.513 18.1056V18.1661C150.513 19.3751 150.297 20.433 149.862 21.3448C149.426 22.2567 148.83 23.0173 148.074 23.6319C147.318 24.2465 146.431 24.705 145.415 25.0123C144.398 25.3196 143.311 25.4757 142.15 25.4757H138.694V31.7174H134.142V10.9168ZM142.295 21.4103C143.437 21.4103 144.323 21.1081 144.954 20.5035C145.585 19.899 145.901 19.1534 145.901 18.2618V18.2013C145.901 17.1736 145.57 16.3878 144.909 15.8538C144.248 15.3198 143.347 15.0528 142.205 15.0528H138.689V21.4154H142.295V21.4103Z"
            fill="#49994C"
          />
          <path
            d="M158.696 15.1384H152.401V10.9168H169.538V15.1384H163.243V31.7225H158.691V15.1384H158.696Z"
            fill="#49994C"
          />
          <path
            d="M69.8818 10.9168H85.4512V14.9873H74.3739V19.2089H98.6469V23.2793H74.3739V27.647H85.6015V31.7174H69.8818V10.9168Z"
            fill="#01344A"
          />
          <path
            d="M25.2659 10.3868L28.6042 12.3013L19.5461 17.8172V22.8518L35.5174 13.7398V10.8629L17.6378 0.312347L0 11.106V16.3787L17.7561 5.82821L21.2127 7.74789L0 19.9749V25.2527L25.2659 10.3868Z"
            fill="#01344A"
          />
          <path
            d="M31.6733 19.3813L31.7093 28.3536L17.8778 36.5239L6.49477 30.0404L16.8594 24.0537V19.0191L0.234863 28.9383V31.6755L17.8778 42.1898L35.7522 31.541V16.97L31.6733 19.3813Z"
            fill="#50A854"
          />
        </svg>
      </div>
      <div className="contact-us-container">
        <span className="contact-us-text">For more information, </span>
        <button
          className="contact-us-button"
          onClick={() =>
            (window.location.href = "https://www.medrpt.ai/contact-us")
          }
        >
          <span className="contact-us-button-text">Contact Us</span>
          <svg
            className="contact-us-icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="share-wrapper" ref={popoverRef}>
          <button
            className="share-button"
            onClick={() => setShareOpen((o) => !o)}
            aria-label="Share"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
            </svg>
            <span className="contact-us-button-text">Share</span>
          </button>

          {shareOpen && (
            <div className="share-popover">
              <p className="share-popover-title">Share MedRPT</p>
              <div className="share-popover-items">
                {PLATFORMS.map((p) => (
                  <a
                    key={p.key}
                    href={p.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="share-popover-item"
                    onClick={() => setShareOpen(false)}
                  >
                    <span className="share-popover-icon" style={{ color: p.color }}>
                      {p.icon}
                    </span>
                    <span className="share-popover-label">{p.label}</span>
                  </a>
                ))}
                <button className="share-popover-item" onClick={handleCopyLink}>
                  <span className="share-popover-icon" style={{ color: "#6b7280" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                  </span>
                  <span className="share-popover-label">
                    {copied ? "Copied!" : "Copy link"}
                  </span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
